import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { Pattern } from "@dffedb/util";

export class FlyttemeddelelseUdflytterFormBuilder {
    public static opretForm(erUdflytterMailSynlig: boolean): UntypedFormGroup {
        const formBuilder = new UntypedFormBuilder();
        const result = formBuilder.group({
            navn: [null, Validators.required],
            mail: [null, [Validators.email]],
            erUdflytterMailSynlig: [erUdflytterMailSynlig, Validators.required],
            adresse: formBuilder.group({
                vejnavn: [null, [Validators.required, Validators.maxLength(30)]],
                postnr: [null, [Validators.required, Validators.pattern(Pattern.postNr)]],
                by: [null, Validators.required]
            }),
            datoForUdflytning: [null, Validators.required]
        });
        if (!erUdflytterMailSynlig) {
            result.get("erUdflytterMailSynlig").disable();
        }
        return result;
    }
}
